import AnimateOptions from './AnimateOptions';
import AnimationOptions from './AnimationOptions';
import MathUtils from '../math/MathUtils';
export default class Animation {
    constructor(options) {
        this.animationInProgress = false;
        this.reversed = false;
        this.reversedEasing = false;
        this.effectiveProgress = 0;
        this.initialProgress = 0;
        this.restartEasing = false;
        this.restartTiming = false;
        this.options = new AnimationOptions(options);
        this.step = this.step.bind(this);
    }
    animate(options) {
        options = new AnimateOptions(options);
        if (!this.options.enabled) {
            this.complete();
            return this;
        }
        this.animationInProgress = true;
        this.reversed = options.reversed;
        this.startTime = undefined;
        if (options.restart) {
            this.effectiveProgress = options.reversed ? 1 : 0;
        }
        this.initialProgress = this.effectiveProgress;
        this.restartEasing = options.restartEasing || options.restart;
        this.restartTiming = options.restartTiming || options.restart;
        this.animationFrameRequestId = window.requestAnimationFrame(this.step);
        return this;
    }
    animateForward(options) {
        options = new AnimateOptions(Object.assign({}, options, { reversed: false }));
        return this.animate(options);
    }
    animateReverse(options) {
        options = new AnimateOptions(Object.assign({}, options, { reversed: true }));
        return this.animate(options);
    }
    setEffectiveProgress(effectiveProgress, reverse = false) {
        if (reverse) {
            effectiveProgress = 1 - effectiveProgress;
        }
        this.effectiveProgress = effectiveProgress;
        this.applyProgress(effectiveProgress);
    }
    setEffectiveProgressEased(effectiveProgress) {
        this.effectiveProgress = effectiveProgress;
        if (this.restartEasing) {
            effectiveProgress = MathUtils.rescale(effectiveProgress, this.initialProgress, this.reversed ? 0 : 1, 0, 1);
        }
        effectiveProgress = this.options.easingFunction(this.reversedEasing ? (1 - effectiveProgress) : effectiveProgress);
        if (this.restartEasing) {
            effectiveProgress = MathUtils.rescale(effectiveProgress, 0, 1, this.initialProgress, this.reversed ? 0 : 1);
        }
        this.applyProgress(effectiveProgress);
    }
    cancel() {
        if (this.animationFrameRequestId !== undefined) {
            window.cancelAnimationFrame(this.animationFrameRequestId);
        }
        this.animationInProgress = false;
    }
    complete() {
        this.cancel();
        this.setEffectiveProgressEased(this.reversed ? 0 : 1);
        if (this.options.onCompleted) {
            this.options.onCompleted(this);
        }
    }
    step(timestamp) {
        if (!this.startTime) {
            this.startTime = timestamp;
            if (!this.restartTiming) {
                this.startTime += this.options.duration * this.initialProgress;
            }
        }
        const durationProgress = (timestamp - this.startTime) / this.options.duration;
        let effectiveProgress;
        if (this.reversed) {
            effectiveProgress = this.initialProgress - (durationProgress * this.initialProgress);
        }
        else {
            effectiveProgress = this.initialProgress + (durationProgress * (1 - this.initialProgress));
        }
        if (durationProgress < 1) {
            this.setEffectiveProgressEased(effectiveProgress);
            this.animationFrameRequestId = window.requestAnimationFrame(this.step);
        }
        else {
            this.complete();
        }
    }
    applyProgress(effectiveProgress) {
        if (this.options.progressFunction) {
            this.options.progressFunction(this, effectiveProgress);
        }
    }
}
//# sourceMappingURL=Animation.js.map